// extracted by mini-css-extract-plugin
export var avatarContainer = "_es-0";
export var avatarTypingWave = "_es-i";
export var gray = "_es-f";
export var green = "_es-c";
export var icon = "_es-9";
export var image = "_es-1";
export var lg = "_es-6";
export var md = "_es-5";
export var presenceDot = "_es-b";
export var red = "_es-d";
export var sm = "_es-4";
export var status = "_es-a";
export var typingDot = "_es-h";
export var typingPill = "_es-g";
export var xl = "_es-7";
export var xs = "_es-3";
export var xxl = "_es-8";
export var xxs = "_es-2";
export var yellow = "_es-e";